import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useActiveSchema } from '../../../../branches/hooks/use-active-schema.ts';
import { submitForm } from '../../../../schema-form/actions.ts';
import { TOOL_FORM_NAME } from '../../constants.ts';
import { useToolStore } from '../../tool-store.ts';

export const useToolEditRun = () => {
  const dispatch = useDispatch();
  const runEditOpen = useToolStore((state) => state.runEditOpen);
  const closeModal = useToolStore((state) => state.closeModal);
  const runEditToolName = useToolStore((state) => state.runEditToolName);
  const { hasPendingChanges } = useActiveSchema();

  const handleSubmit = useCallback(() => {
    dispatch(submitForm(TOOL_FORM_NAME));
  }, [dispatch]);

  return {
    runEditOpen,
    closeModal,
    runEditToolName,
    hasPendingChanges,
    handleSubmit
  };
};

export type ToolRunEditProps = ReturnType<typeof useToolEditRun>;
